import { render } from "./QTrash.vue?vue&type=template&id=df66c756"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/QTrash.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "df66c756"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('df66c756', __exports__)) {
    api.reload('df66c756', __exports__)
  }
  
  module.hot.accept("./QTrash.vue?vue&type=template&id=df66c756", () => {
    api.rerender('df66c756', render)
  })

}


export default __exports__